import * as React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, NumericTextBox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { useState, useEffect, useRef } from "react";
import { TextArea } from "@progress/kendo-react-inputs";
import styles from "./Matter.module.scss";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import AddClients from "pages/Clients/AddViewClients";
import { Button } from "@progress/kendo-react-buttons";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import { useBranches } from "services/branchService";
import {
  addMatter,
  getMatterAllInfo,
  getMatterRefExample,
  updateMatter,
  getWorkType,
  editAccessibleUsers,
  getRateCategoriesbyAppCode,
} from "api/index";
import { useNominalsBySubType } from "services/nominalsService";
import { FormComboBox, FormInput, FormDate } from "components/Matters/index";
import { CONSTANT } from "CONSTANT/Matter/MatterForm";
import { filterBy } from "@progress/kendo-data-query";
import { toast } from "react-toastify";
import { Tile } from "components/UIComponents/Tile";
import Loader from "components/common/Loading";
import MatterView from "./MatterViewPage";
import { MatterPermissions } from "./MatterPermissions";
import { getMattersAllInfo } from "actions/matters.action";
import EstimateFeeImage from "../../assets/estimate-fee.png";
import EstimateFee from "./EstimateFee";
import { useCurrentUser } from "services/currentUserService";
import { useActiveFeeEarner } from "services/userService";
import { useActiveDepartments } from "services/departmentService";
import { useActiveWorkTypes } from "services/workTypeService";
import { useActiveApplications } from "services/applicationService";
import { getActiveInterestSchemes } from "services/interestCalculatorService";
import UndertakingsList from "components/Undertakings/UndertakingsList";
import { TileWrapper } from "components/UIComponents/TileWrapper.jsx";
import { useActiveSources } from "services/sourcesService";
import { useActiveReferrers } from "services/referrersService";
import Asterisk from "components/common/Asterisk";

const MatterForm = (props) => {
  const [formType, setFormType] = useState(() => {
    if (props.reference && props.isView) return "VIEW";
    else return "ADD_NEW";
  });
  const { data: branchesList, loading: branchesLoading } = useBranches();
  const { data: user } = useCurrentUser();
  const { data: activeFeeEarner } = useActiveFeeEarner();
  const { data: departmentData } = useActiveDepartments();
  const { data: categoryData } = useActiveWorkTypes();
  const { data: activeApplications, loading: isLoadingApplications } =
    useActiveApplications();

  const matterDetails = useSelector((state) => state.mattersList);
  const { data: activeSourcesData } = useActiveSources();
  const { data: activeReferrersData } = useActiveReferrers();
  const { data: incomeNominals } = useNominalsBySubType("ProfitAndLoss_Income", {
    excludeArchived: true,
  });
  const { data: ddaBankNominals } = useNominalsBySubType(
    "BalanceSheet_DDABank",
    { excludeArchived: true },
  );

  const [details, setDetails] = useState("");
  const dispatch = useDispatch();
  const [feeEarner, setFeeEarner] = useState(activeFeeEarner || []);
  const [departmentFilter, setDepartmentFilter] = useState(
    departmentData || [],
  );
  const [categoryFilter, setCategoryFilter] = useState(categoryData || []);
  const [superVisor, setSuperVisor] = useState(activeFeeEarner || []);
  const [profitAndLoss, setProfitAndLoss] = useState([]);
  const [ddaBankList, setDdaBankList] = useState([]);

  const [addClient, setAddClient] = useState(false);
  const [applicationFilter, setApplicationFilter] = useState([]);
  const [accessibleUsers, setAccessibleUsers] = useState([]);
  const [newMaterId, setNewMatterId] = useState(undefined);
  const [closed, setClosed] = useState(false);

  const [deleted, setDeleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rateCategories, setRateCategories] = useState([]);
  const [matterDetailsData, setMatterDetailsData] = useState(null);
  const [interestSchemes, setInterestSchemes] = useState([]);
  const [validation, setValidation] = useState(false);
  const formRef = useRef(null);

  const [inputState, setInputState] = useState({
    [CONSTANT.INPUT.LOCATION]: "",
    [CONSTANT.COMBOBOX.MATTER_REF]: "",
    [CONSTANT.INPUT.WIP_CREDIT_LIMIT]: "",
    [CONSTANT.INPUT.DISP_CREDIT_LIMIT]: "",
    [CONSTANT.INPUT.BILL_CREDIT_LIMIT]: "",
    [CONSTANT.INPUT.LAST_NAME_OS1]: "",
    [CONSTANT.INPUT.FIRST_NAME_OS2]: "",
    [CONSTANT.INPUT.FIRST_NAME_OS2]: "",
    [CONSTANT.INPUT.LAST_NAME_OS2]: "",
    [CONSTANT.INPUT.POST_CODE_OS1]: "",
    [CONSTANT.INPUT.POST_CODE_OS2]: "",
    [CONSTANT.INPUT.CONTACT]: "",
  });

  const [comboBoxState, setComboBoxState] = useState({
    [CONSTANT.COMBOBOX.CLIENT]: "",
    [CONSTANT.COMBOBOX.SUPERVISIOR]: "",
    [CONSTANT.COMBOBOX.FEE_EARNER]: user?.isFeeEarner
      ? {
          userRef: user?.userRef,
          display: `${user?.userRef} - ${user.displayname} `,
        }
      : null,
    [CONSTANT.COMBOBOX.APPLICATION]: "",
    [CONSTANT.COMBOBOX.DEPARTMENT]: "",
    [CONSTANT.COMBOBOX.CATEGORY]: "",
    [CONSTANT.COMBOBOX.BRANCH]: "",
    [CONSTANT.COMBOBOX.DDA_BANK]: "",
    [CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL]: "",
    [CONSTANT.COMBOBOX.INTEREST_SCHEME]: "",
    [CONSTANT.COMBOBOX.CONTACT_LINK]: "",
    [CONSTANT.COMBOBOX.RATE_TYPE]: "",
    accessibleUser: "",
  });

  const [dateState, setDateState] = useState({
    [CONSTANT.DATE.START_DATE]: new Date(),
    [CONSTANT.DATE.CLOSED_DATE]: "",
    [CONSTANT.DATE.DELETED_DATE]: "",
    [CONSTANT.DATE.DOB_OS1]: "",
    [CONSTANT.DATE.DOB_OS2]: "",
    Opened: new Date(),
  });

  function safeDisplay(...parts) {
    return parts.filter(Boolean).join(" - ");
  }

  const [showEstimatedFee, setShowEstimatedFee] = useState(false);

  useEffect(() => {
    if (activeFeeEarner) {
      setFeeEarner(activeFeeEarner);
      setSuperVisor(activeFeeEarner);
    }
  }, [activeFeeEarner?.length]);

  useEffect(() => {
    if (departmentData) {
      setDepartmentFilter(departmentData);
    }
  }, [departmentData]);
  useEffect(() => {
    if (categoryData) {
      setCategoryFilter(categoryData);
    }
  }, [categoryData]);

  useEffect(() => {
    if (activeApplications) {
      setApplicationFilter(activeApplications);
    }
  }, [activeApplications]);

  useEffect(() => {
    setProfitAndLoss(incomeNominals || []);
  }, [incomeNominals]);

  useEffect(() => {
    setDdaBankList(ddaBankNominals || []);
  }, [ddaBankNominals]);

  useEffect(() => {
    if (
      comboBoxState[CONSTANT.COMBOBOX.CATEGORY]?.workTypeID &&
      formType === "ADD_NEW"
    ) {
      getWorkTypeData();
    }
  }, [comboBoxState[CONSTANT.COMBOBOX.CATEGORY]?.workTypeID]);

  const getWorkTypeData = async () => {
    setLoading(true);
    const { data } = await getWorkType(
      comboBoxState[CONSTANT.COMBOBOX.CATEGORY]?.workTypeID,
    );
    const response = data.data;

    setInputState((prevState) => ({
      ...prevState,
      [CONSTANT.INPUT.WIP_CREDIT_LIMIT]: response?.wipCreditLimit || "",
      [CONSTANT.INPUT.DISP_CREDIT_LIMIT]: response?.disbCreditLimit || "",
      [CONSTANT.INPUT.BILL_CREDIT_LIMIT]: response?.billCreditLimit || "",
    }));

    const appItem = activeApplications?.find(
      (item) => item.appCode === response.appCode,
    );
    const profitAndLossItem = profitAndLoss.find(
      (item) => item.nominalRef === response.defaultProfitCost,
    );
    setComboBoxState((prevState) => ({
      ...prevState,
      [CONSTANT.COMBOBOX.APPLICATION]: appItem,
      [CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL]: profitAndLossItem || null,
    }));
    setLoading(false);
  };

  const filterFeeEarner = (filter) => {
    const data = activeFeeEarner?.slice();
    return filterBy(data, filter);
  };
  const feeEarnerfilterChange = (event) => {
    setFeeEarner(filterFeeEarner(event.filter));
  };

  const filterProfitAndLoss = (filter) => {
    const data = (incomeNominals || []).slice();
    return filterBy(data, filter);
  };
  const profitAndLossfilterChange = (event) => {
    setProfitAndLoss(filterProfitAndLoss(event.filter));
  };

  const filterDdaBank = (filter) => {
    const data = (ddaBankNominals || []).slice();
    return filterBy(data, filter);
  };
  const ddaBankFilterChange = (event) => {
    setDdaBankList(filterDdaBank(event.filter));
  };

  const filterInterestSchemes = (filter) => {
    const data = interestSchemes.slice();
    return filterBy(data, filter);
  };

  const interestSchemesFilterChange = (event) => {
    setInterestSchemes(filterInterestSchemes(event.filter));
  };

  const filterSuperVisor = (filter) => {
    const data = activeFeeEarner?.slice();
    return filterBy(data, filter);
  };
  const superVisorfilterChange = (event) => {
    setSuperVisor(filterSuperVisor(event.filter));
  };

  const filterrApplication = (filter) => {
    const data = (activeApplications || []).slice();
    return filterBy(data, filter);
  };
  const applicationfilterChange = (event) => {
    setApplicationFilter(filterrApplication(event.filter));
  };

  const filterDepartment = (filter) => {
    const data = departmentData.slice();
    return filterBy(data, filter);
  };
  const departmentfilterChange = (event) => {
    setDepartmentFilter(filterDepartment(event.filter));
  };

  const filterCategory = (filter) => {
    const data = categoryData.slice();
    return filterBy(data, filter);
  };
  const categoryFilterChange = (event) => {
    setCategoryFilter(filterCategory(event.filter));
  };

  const isDuplicateMatterError = (err) => {
    const errData = err?.response?.data ?? err?.data;
    const errMessage = errData?.errorMessage;
    return (
      typeof errMessage === "string" &&
      errMessage.includes("The duplicate key value is")
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidation(true);
    const isFormValid = formRef.current?.checkValidity();
    if (!isFormValid) return;

    const parseDate = (newDate) => {
      if (!newDate) return null;
      var os = newDate?.getTimezoneOffset();
      return (newDate = new Date(newDate.getTime() - os * 60 * 1000));
    };
    const dataObject = {
      matterRef: inputState[CONSTANT.INPUT.MATTER_REF] || null,
      details: details,
      estimate: inputState["estimateValue"],
      feeEarnerRef: comboBoxState[CONSTANT.COMBOBOX.FEE_EARNER].userRef || null,
      clientId: comboBoxState[CONSTANT.COMBOBOX.CLIENT].CustomerID || null,
      supervisorRef:
        comboBoxState[CONSTANT.COMBOBOX.SUPERVISIOR]?.userRef || null,
      appCode: comboBoxState[CONSTANT.COMBOBOX.APPLICATION].appCode || null,
      branchId: comboBoxState[CONSTANT.COMBOBOX.BRANCH].branchId || null,
      startDate: parseDate(dateState[CONSTANT.DATE.START_DATE]) || null,
      dateCompleted: parseDate(dateState[CONSTANT.DATE.CLOSED_DATE]) || null,
      otherside1_Firstname: inputState[CONSTANT.INPUT.FIRST_NAME_OS1] || null,
      otherside1_Lastname: inputState[CONSTANT.INPUT.LAST_NAME_OS1] || null,
      customField1: null,
      otherside1_Postcode: inputState[CONSTANT.INPUT.POST_CODE_OS1] || null,
      otherside1_DateOfBirth:
        parseDate(dateState[CONSTANT.DATE.DOB_OS1]) || null,
      otherside2_Lastname: inputState[CONSTANT.INPUT.LAST_NAME_OS2] || null,
      otherside2_Firstname: inputState[CONSTANT.INPUT.FIRST_NAME_OS2] || null,
      otherside2_Postcode: inputState[CONSTANT.INPUT.POST_CODE_OS2] || null,
      otherside2_DateOfBirth:
        parseDate(dateState[CONSTANT.DATE.DOB_OS2]) || null,
      wipCreditLimit: inputState[CONSTANT.INPUT.WIP_CREDIT_LIMIT] || null,
      disbCreditLimit: inputState[CONSTANT.INPUT.DISP_CREDIT_LIMIT] || null,
      billCreditLimit: inputState[CONSTANT.INPUT.BILL_CREDIT_LIMIT] || null,
      defaultDDABank:
        comboBoxState[CONSTANT.COMBOBOX.DDA_BANK]?.nominalRef || -1,
      defaultProfitCost:
        comboBoxState[CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL]?.nominalRef || -1,
      interestSchemeId:
        comboBoxState[CONSTANT.COMBOBOX.INTEREST_SCHEME]?.interestSchemeId ||
        -1,
      departmentId:
        comboBoxState[CONSTANT.COMBOBOX.DEPARTMENT]?.departmentID || -1,
      workTypeId: comboBoxState[CONSTANT.COMBOBOX.CATEGORY]?.workTypeID || -1,
      sourceId: comboBoxState[CONSTANT.COMBOBOX.SOURCE]?.sourceID || -1,
      referrerId: comboBoxState[CONSTANT.COMBOBOX.REFERRRER]?.referrerID || -1,
      location: inputState[CONSTANT.INPUT.LOCATION] || null,
      closed: closed,
      dateClosed: parseDate(dateState[CONSTANT.DATE.CLOSED_DATE]) || null,
      matterAccess: accessibleUsers?.length ? accessibleUsers : undefined,
      status: "Open",
      rateType: comboBoxState[CONSTANT.COMBOBOX.RATE_TYPE]?.rateType || null,
      rateValue: inputState["rateValue"],
      rateCategoryId:
        comboBoxState[CONSTANT.COMBOBOX.RATE_TYPE]?.rateType === "RateCategory"
          ? comboBoxState[CONSTANT.COMBOBOX.RATE_CATEGORY]?.rateCategoryId
          : null,
    };

    if (formType === "EDIT") {
      try {
        const res = await updateMatter(
          matterDetails?.matterViewDetails[props.reference]?.data?.matterId,
          { data: dataObject },
        );
        if (res?.status === 200) {
          toast.success("Matter Updated Successfully");
          const matterId =
            matterDetails?.matterViewDetails[props.reference]?.data?.matterId;
          dispatch(getMattersAllInfo(matterId));
          setFormType("VIEW");
          if (props.onMatterUpdated) {
            props.onMatterUpdated();
          }
        }
        return;
      } catch (err) {
        if (isDuplicateMatterError(err)) {
        } else {
        }
      }
    } else {
      try {
        const res = await addMatter({ data: dataObject });
        if (res?.status === 200) {
          toast.success("Matter Added Successfully");
          const matterId = res.data.data.matterId;
          setNewMatterId(matterId);
          dispatch(
            getMattersAllInfo(
              matterDetails?.matterViewDetails[props.reference]?.data
                ?.matterId || matterId,
            ),
          );
          setFormType("VIEW");
          if (props.onMatterUpdated) {
            props.onMatterUpdated();
          }
          if (props.onMatterRefClickActions) {
            props.onMatterRefClickActions({
              dataItem: {
                matterId,
                matterRef: inputState[CONSTANT.INPUT.MATTER_REF],
                matterDetails: details,
              },
            });
          }
        }
      } catch (err) {
        if (isDuplicateMatterError(err)) {
        } else {
        }
      }
    }
  };

  // Load matter data when switching to EDIT mode
  useEffect(() => {
    if (
      formType === "EDIT" &&
      matterDetails?.matterViewDetails[props.reference]?.data?.matterId
    ) {
      getMatterData();
    }
  }, [formType, props.reference, ddaBankNominals, incomeNominals]);

  const [selected, setSelected] = React.useState(0);
  const handleSelect = (e) => {
    setSelected(e.selected);
  };

  const getMatterData = async () => {
    const res = await getMatterAllInfo(
      matterDetails?.matterViewDetails[
        props.reference || inputState[CONSTANT.INPUT.MATTER_REF]
      ]?.data?.matterId,
    );
    const { data } = res;
    setDetails(data.data.details);
    setMatterDetailsData(data.data);
    setInputState({
      [CONSTANT.INPUT.MATTER_REF]: data.data.matterRef || "",
      [CONSTANT.INPUT.LAST_NAME_OS1]: data.data.otherside1_Lastname || "",
      [CONSTANT.INPUT.FIRST_NAME_OS1]: data.data.otherside1_Firstname || "",
      [CONSTANT.INPUT.FIRST_NAME_OS2]: data.data.otherside2_Firstname || "",
      [CONSTANT.INPUT.LAST_NAME_OS2]: data.data.otherside2_Lastname || "",
      [CONSTANT.INPUT.POST_CODE_OS1]: data.data.otherside1_Postcode || "",
      [CONSTANT.INPUT.POST_CODE_OS2]: data.data.otherside2_Postcode || "",
      [CONSTANT.INPUT.WIP_CREDIT_LIMIT]: data.data.wipCreditLimit || "",
      [CONSTANT.INPUT.DISP_CREDIT_LIMIT]: data.data.disbCreditLimit || "",
      [CONSTANT.INPUT.BILL_CREDIT_LIMIT]: data.data.billCreditLimit || "",
      [CONSTANT.INPUT.LOCATION]: data.data.location || "",
      ["estimateValue"]: data.data.estimate || "",
      ["rateValue"]: data.data.rateValue || "",
    });
    const applicationState = {
      display:
        data?.data?.appCode && data?.data?.application
          ? `${data.data.appCode} - ${data.data.application}`
          : "",
    };

    setComboBoxState((prevState) => ({
      [CONSTANT.COMBOBOX.BRANCH]:
        branchesList?.find((b) => b.branchId === data.data.branchId) || {
          branchId: data.data.branchId,
          branchName: data.data.branch,
        },
      [CONSTANT.COMBOBOX.FEE_EARNER]: {
        display: safeDisplay(data.data.feeEarnerRef, data.data.feeEarnerName),
        userRef: data.data.feeEarnerRef,
      },
      [CONSTANT.COMBOBOX.DDA_BANK]:
        ddaBankNominals?.find(
          (bank) => bank.nominalRef === data.data.defaultDDABank,
        ) || null,
      [CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL]:
        incomeNominals?.find(
          (nominal) => nominal.nominalRef === data.data.defaultProfitCost,
        ) || null,
      [CONSTANT.COMBOBOX.INTEREST_SCHEME]: data.data.interestSchemeId
        ? {
            interestSchemeId: data.data.interestSchemeId,
            schemeName: data.data.interestSchemeName,
          }
        : null,
      [CONSTANT.COMBOBOX.CLIENT]: {
        CustomerID: data.data.client?.clientId,
        ContactName: data.data.client?.clientName,
        display: data.data.client?.display,
        CustomerRef: data.data.client?.clientRef,
      },
      [CONSTANT.COMBOBOX.APPLICATION]: applicationState,
      [CONSTANT.COMBOBOX.SUPERVISIOR]: {
        display: safeDisplay(data.data.supervisorRef, data.data.supervisorName),
        userRef: data.data.supervisorRef,
      },
      [CONSTANT.COMBOBOX.REFERRRER]: {
        referrerName: data.data.referrer,
        referrerID: data.data.referrerId,
      },
      [CONSTANT.COMBOBOX.SOURCE]: {
        sourceName: data.data.source,
        sourceID: data.data.sourceId,
      },
      [CONSTANT.COMBOBOX.DEPARTMENT]: {
        name: data.data.department,
        departmentID: data.data.departmentId,
      },
      [CONSTANT.COMBOBOX.CATEGORY]: {
        name: data.data.workType,
        workTypeID: data.data.workTypeId,
      },
      [CONSTANT.COMBOBOX.RATE_TYPE]: {
        rateType: data.data.rateType,
        representation:
          data.data.rateType === "MatterFlatRate"
            ? "Matter Flat Rate"
            : data.data.rateType === "FeeEarnerDefault"
              ? "Fee Earner Default"
              : "Rate Category",
      },
      [CONSTANT.COMBOBOX.RATE_CATEGORY]:
        data.data.rateType === "RateCategory"
          ? {
              rateCategoryId: data.data.rateCategoryId,
              rateCategoryName: data.data.rateCategory,
              representation: data.data.rateCategory,
            }
          : null,
    }));

    setDateState({
      [CONSTANT.DATE.START_DATE]: new Date(data.data.startDate),
      [CONSTANT.DATE.CLOSED_DATE]: data.data.dateCompleted
        ? new Date(data.data.dateCompleted)
        : null,
      [CONSTANT.DATE.DOB_OS1]: data.data.otherside1_DateOfBirth
        ? new Date(data.data.otherside1_DateOfBirth)
        : null,
      [CONSTANT.DATE.DOB_OS2]: data.data.otherside2_DateOfBirth
        ? new Date(data.data.otherside2_DateOfBirth)
        : null,
    });
    setClosed(data?.data?.closed);
    setAccessibleUsers(data?.data?.matterAccess);
  };

  const handleInputChange = (value, label) => {
    if (formType === "EDIT" && label === CONSTANT.INPUT.MATTER_REF) return;
    setInputState({ ...inputState, [label]: value });
  };

  // Helper function to fetch and set rate categories
  const fetchRateCategories = async (appCode) => {
    try {
      const rateCategoriesData = await getRateCategoriesbyAppCode(appCode);
      const categories = rateCategoriesData?.data?.data || [];
      setRateCategories(categories);
      return categories;
    } catch (error) {
      console.error("Error fetching rate categories:", error);
      return [];
    }
  };

  // Helper function to restore existing rate category in EDIT mode
  const restoreExistingRateCategory = (categories) => {
    if (
      formType === "EDIT" &&
      comboBoxState[CONSTANT.COMBOBOX.RATE_CATEGORY]?.rateCategoryId
    ) {
      const existingCategory = categories.find(
        (rc) =>
          rc.rateCategoryId ===
          comboBoxState[CONSTANT.COMBOBOX.RATE_CATEGORY]?.rateCategoryId,
      );

      if (existingCategory) {
        setComboBoxState((prev) => ({
          ...prev,
          [CONSTANT.COMBOBOX.RATE_CATEGORY]: {
            rateCategoryId: existingCategory.rateCategoryId,
            rateCategoryName: existingCategory.rateCategoryName,
            representation: existingCategory.rateCategoryName,
          },
        }));
      }
    }
  };

  // Helper function to handle rate category logic
  const handleRateCategoryLogic = async (appCode) => {
    if (appCode) {
      const categories = await fetchRateCategories(appCode);
      restoreExistingRateCategory(categories);
    }
  };

  const handleComboBoxChange = async (e, label) => {
    // Handle Rate Type changes with null safety
    if (label === CONSTANT.COMBOBOX.RATE_TYPE) {
      if (e.value && typeof e.value === "object") {
        const newRateType = {
          ...e.value,
          representation: e.value.representation || e.value.value,
        };

        setComboBoxState((prevState) => ({
          ...prevState,
          [label]: newRateType,
        }));

        // Handle rate category logic based on rate type
        if (newRateType.rateType === "RateCategory") {
          const appCode = comboBoxState[CONSTANT.COMBOBOX.APPLICATION]?.appCode;
          await handleRateCategoryLogic(appCode);
        } else {
          // Clear rate category if switching away from RateCategory
          setComboBoxState((prev) => ({
            ...prev,
            [CONSTANT.COMBOBOX.RATE_CATEGORY]: null,
          }));
        }
      } else {
        // Handle null/undefined values
        setComboBoxState((prevState) => ({
          ...prevState,
          [label]: e.value || "",
        }));
      }
      return;
    }

    // Handle Application changes
    if (label === CONSTANT.COMBOBOX.APPLICATION) {
      setComboBoxState((prevState) => ({ ...prevState, [label]: e.value }));

      // Fetch rate categories if Rate Type is already set to "RateCategory"
      const currentRateType = comboBoxState[CONSTANT.COMBOBOX.RATE_TYPE];
      if (e.value?.appCode && currentRateType?.rateType === "RateCategory") {
        await handleRateCategoryLogic(e.value.appCode);
      }
      return;
    }

    // Handle all other combobox changes
    setComboBoxState((prevState) => ({
      ...prevState,
      [label]:
        label === CONSTANT.COMBOBOX.INTEREST_SCHEME ||
        label === CONSTANT.COMBOBOX.DDA_BANK ||
        label === CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL
          ? e.value || null
          : e.value,
    }));
  };

  const handleDateChange = (e, label) => {
    setDateState({ ...dateState, [label]: e.value });
  };

  const handleAccesibleUsers = async (matterId, feeEarnerRef, type) => {
    try {
      if (type === "add") {
        await editAccessibleUsers(matterId, [
          { feeEarnerRef: feeEarnerRef, active: true },
        ]);
      } else {
        await editAccessibleUsers(matterId, [
          { feeEarnerRef: feeEarnerRef, active: false },
        ]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (formType === "EDIT" || formType === "ADD_NEW") {
      getInterestSchemes();

      // Handle existing application in EDIT mode
      if (
        formType === "EDIT" &&
        comboBoxState[CONSTANT.COMBOBOX.APPLICATION] &&
        activeApplications
      ) {
        const existingApp = activeApplications.find(
          (app) =>
            app.appCode ===
            comboBoxState[CONSTANT.COMBOBOX.APPLICATION].appCode,
        );
        if (existingApp) {
          setComboBoxState((prev) => ({
            ...prev,
            [CONSTANT.COMBOBOX.APPLICATION]: existingApp,
          }));
        }
      }
    }
  }, [formType, activeApplications]);

  const getInterestSchemes = async () => {
    try {
      const schemesData = await getActiveInterestSchemes();
      setInterestSchemes(schemesData || []);
    } catch (error) {
      console.error("Error loading interest schemes:", error);
    }
  };

  const handleClientChange = async (value) => {
    if (formType === "EDIT") return;
    if (value !== null) {
      try {
        const response = await getMatterRefExample(value.CustomerRef);
        setInputState((prev) => ({
          ...prev,
          [CONSTANT.INPUT.MATTER_REF]: response.data,
        }));
      } catch (error) {}

      setComboBoxState((prev) => {
        const next = {
          ...prev,
          [CONSTANT.COMBOBOX.CLIENT]: value,
        };

        if (branchesList?.length) {
          const byId = value.branchId
            ? branchesList.find((b) => b.branchId === value.branchId)
            : null;
          const byName =
            !byId && value.branchName
              ? branchesList.find((b) => b.branchName === value.branchName)
              : null;
          if (byId || byName) {
            next[CONSTANT.COMBOBOX.BRANCH] = byId || byName;
          }
        }
        return next;
      });
    } else {
      setComboBoxState((prev) => ({
        ...prev,
        [CONSTANT.COMBOBOX.CLIENT]: null,
      }));
    }
  };

  useEffect(() => {
    if (branchesList?.length && user?.branchId && formType === "ADD_NEW") {
      const defaultBranch = branchesList.find(
        (branch) => branch.branchId === user.branchId,
      );
      if (!defaultBranch) return;
      setComboBoxState((prev) => {
        if (prev[CONSTANT.COMBOBOX.BRANCH]) return prev;
        return {
          ...prev,
          [CONSTANT.COMBOBOX.BRANCH]: defaultBranch,
        };
      });
    }
  }, [branchesList, user?.branchId, formType]);

  useEffect(() => {
    const fetchRateCategories = async () => {
      if (matterDetailsData?.appCode) {
        try {
          const rateCategoriesData = await getRateCategoriesbyAppCode(
            matterDetailsData?.appCode,
          );
          setRateCategories(rateCategoriesData?.data?.data || []);

          if (
            formType === "EDIT" &&
            comboBoxState[CONSTANT.COMBOBOX.RATE_TYPE]?.rateType ===
              "RateCategory"
          ) {
            const existingCategory = rateCategoriesData?.data?.data?.find(
              (rc) => rc.rateCategoryId === matterDetailsData?.rateCategoryId,
            );
            if (existingCategory) {
              setComboBoxState((prev) => ({
                ...prev,
                [CONSTANT.COMBOBOX.RATE_CATEGORY]: {
                  rateCategoryId: existingCategory.rateCategoryId,
                  rateCategoryName: existingCategory.rateCategoryName,
                  representation: existingCategory.rateCategoryName,
                },
              }));
            }
          }
        } catch (error) {
          console.error("Error fetching rate categories:", error);
        }
      }
    };
    fetchRateCategories();
  }, [matterDetailsData?.appCode]);

  useEffect(() => {
    // Prefill client if provided from ClientsList)
    if (
      formType === "ADD_NEW" &&
      props.clientData &&
      (!comboBoxState[CONSTANT.COMBOBOX.CLIENT] ||
        comboBoxState[CONSTANT.COMBOBOX.CLIENT] === "")
    ) {
      const client = props.clientData;
      setComboBoxState((prev) => ({
        ...prev,
        [CONSTANT.COMBOBOX.CLIENT]: {
          CustomerID: client.clientId,
          ContactName: client.clientName,
          display: client.display,
          CustomerRef: client.clientRef,
        },
      }));
      handleClientChange({
        CustomerID: client.clientId,
        ContactName: client.clientName,
        display: client.display,
        CustomerRef: client.clientRef,
        branchName: client.branchName,
      });
    }
  }, [formType, props.clientData]);

  return (
    <div className={styles["matter-form-dialog1"]}>
      {formType === "VIEW" ? (
        <Dialog
          className="dialog-xxl "
          title={"View Matter"}
          onClose={props.setshowMatterForm}
        >
          <MatterView
            reference={props.reference || inputState[CONSTANT.INPUT.MATTER_REF]}
            editMatter={() => setFormType("EDIT")}
          />

          <DialogActionsBar>
            <div className="dialog-footer">
              <Button
                className="common-btn border-0 me-4"
                style={{ maxWidth: "60px" }}
                onClick={() => {
                  setFormType("EDIT");
                }}
              >
                Edit
              </Button>
            </div>
          </DialogActionsBar>
        </Dialog>
      ) : (
        <Dialog
          className="dialog-xxl add-dialog"
          title={formType === "EDIT" ? "Update Matter" : "Add Matter"}
          onClose={() => {
            if (formType === "ADD_NEW") props.setshowMatterForm();
            else setFormType("VIEW");
          }}
        >
          <div className="px-2 pt-3">
            <div className="row">
              <div className={`styles["view-tittle"] col`}>
                <form
                  id="matterForm"
                  ref={formRef}
                  onSubmit={handleSubmit}
                  className={`${validation ? "validation" : ""}`}
                  noValidate
                >
                  <TabStrip
                    keepTabsMounted={true}
                    selected={selected}
                    onSelect={handleSelect}
                    className="mt-3 px-4 pb-4 pagetab "
                  >
                    <TabStripTab
                      title={
                        <PageTabItemTitle
                          title="Matter Information"
                          index={0}
                          selected={selected}
                        />
                      }
                    >
                      <TileWrapper>
                        {loading ? (
                          <Loader />
                        ) : (
                          <div className="row g-2">
                            <div className="col-12 col-xl-8">
                              <Tile
                                heading="Matter Details"
                                className="px-4 pt-2 overflow-auto h-100"
                              >
                                <div className="px-2">
                                  <div className="container">
                                    <div className="row">
                                      <div className="col-5">
                                        <FormComboBox
                                          fc={true}
                                          name={CONSTANT.COMBOBOX.CLIENT}
                                          val={
                                            comboBoxState[
                                              CONSTANT.COMBOBOX.CLIENT
                                            ]
                                          }
                                          onChangeClient={handleClientChange}
                                          wf={true}
                                          label="Client"
                                          isStyled={true}
                                          width={"260px"}
                                          boxShadow={true}
                                          disabled={formType === "EDIT"}
                                          required={true}
                                          showAsterisk={
                                            !comboBoxState[
                                              CONSTANT.COMBOBOX.CLIENT
                                            ]
                                          }
                                        />
                                      </div>
                                      <div className="col"></div>
                                      <div className="col-6">
                                        <div className="col-6">
                                          <FormComboBox
                                            isStyled={true}
                                            wf={true}
                                            data={branchesList || []}
                                            textField="branchName"
                                            width={"260px"}
                                            boxShadow={true}
                                            state={comboBoxState}
                                            name={CONSTANT.COMBOBOX.BRANCH}
                                            onChangeComboBox={
                                              handleComboBoxChange
                                            }
                                            disabled={branchesLoading}
                                            required={true}
                                            showAsterisk={
                                              !comboBoxState[
                                                CONSTANT.COMBOBOX.BRANCH
                                              ]
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="d-flex flex-column col-5">
                                        <FormInput
                                          required={true}
                                          labelWidth
                                          wf={true}
                                          labelForComboBox={"Reference"}
                                          isStyled={true}
                                          width={"260px"}
                                          boxShadow={true}
                                          state={inputState}
                                          label={CONSTANT.INPUT.MATTER_REF}
                                          onChangeInput={handleInputChange}
                                          disabled={formType === "EDIT"}
                                          showAsterisk={
                                            !inputState[
                                              CONSTANT.INPUT.MATTER_REF
                                            ]?.trim()
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="d-flex flex-column">
                                        <Label className={`label mb-1`}>
                                          Details
                                          {!details?.trim() && <Asterisk />}
                                        </Label>
                                        <TextArea
                                          required
                                          placeholder="Enter Details"
                                          autoSize={true}
                                          value={details}
                                          style={{
                                            height: "62px",
                                            //Rows with 2 fields have second field at col-6 (50%)
                                            //Second field width = 260px + col padding 12px
                                            width: "calc(50% + 272px)",

                                            //.k-input have default max-width set to 326px (override)
                                            maxWidth: "100%",
                                          }}
                                          onChange={(e) => setDetails(e.value)}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-3">
                                      <div className="col-5">
                                        <FormComboBox
                                          wf={true}
                                          isStyled={true}
                                          width={"260px"}
                                          onChangeComboBox={
                                            handleComboBoxChange
                                          }
                                          onFilterChange={feeEarnerfilterChange}
                                          data={feeEarner}
                                          textField="display"
                                          state={comboBoxState}
                                          name={CONSTANT.COMBOBOX.FEE_EARNER}
                                          required={true}
                                          showAsterisk={
                                            !comboBoxState[
                                              CONSTANT.COMBOBOX.FEE_EARNER
                                            ]
                                          }
                                        />
                                      </div>
                                      <div className="col"></div>
                                      <div className="col-6">
                                        <FormDate
                                          className={
                                            "form-date-picker note-date-picker "
                                          }
                                          wf={true}
                                          isStyled={true}
                                          width={"260px"}
                                          customLabel={"Opened"}
                                          label={CONSTANT.DATE.START_DATE}
                                          onChangeDate={handleDateChange}
                                          state={dateState}
                                        />
                                      </div>
                                    </div>

                                    <div className="row mt-3">
                                      <div className="col-5">
                                        <FormComboBox
                                          wf={true}
                                          isStyled={true}
                                          width={"260px"}
                                          onChangeComboBox={
                                            handleComboBoxChange
                                          }
                                          onFilterChange={
                                            superVisorfilterChange
                                          }
                                          data={superVisor}
                                          textField="display"
                                          state={comboBoxState}
                                          name={CONSTANT.COMBOBOX.SUPERVISIOR}
                                        />
                                      </div>
                                      <div className="col"></div>
                                      <div className="col-6">
                                        <FormComboBox
                                          wf={true}
                                          isStyled={true}
                                          width={"260px"}
                                          onChangeComboBox={
                                            handleComboBoxChange
                                          }
                                          textField="name"
                                          onFilterChange={
                                            departmentfilterChange
                                          }
                                          data={departmentFilter}
                                          state={comboBoxState}
                                          name={CONSTANT.COMBOBOX.DEPARTMENT}
                                        />
                                      </div>
                                    </div>

                                    <div className="row my-3">
                                      <div className="col-5">
                                        <FormComboBox
                                          loading={isLoadingApplications}
                                          onChangeComboBox={
                                            handleComboBoxChange
                                          }
                                          wf={true}
                                          isStyled={true}
                                          width={"260px"}
                                          onFilterChange={
                                            applicationfilterChange
                                          }
                                          textField="display"
                                          data={applicationFilter}
                                          state={comboBoxState}
                                          name={CONSTANT.COMBOBOX.APPLICATION}
                                          val={
                                            comboBoxState[
                                              CONSTANT.COMBOBOX.APPLICATION
                                            ]
                                          }
                                        />
                                      </div>
                                      <div className="col"></div>
                                      <div className="col-6">
                                        <div className="d-flex align-items-center gap-2">
                                          <FormComboBox
                                            wf={true}
                                            isStyled={true}
                                            width={"260px"}
                                            onChangeComboBox={
                                              handleComboBoxChange
                                            }
                                            onFilterChange={
                                              categoryFilterChange
                                            }
                                            data={categoryFilter.filter(
                                              (item) =>
                                                item.departmentId ===
                                                comboBoxState[
                                                  CONSTANT.COMBOBOX.DEPARTMENT
                                                ].departmentID,
                                            )}
                                            state={comboBoxState}
                                            textField="name"
                                            name={CONSTANT.COMBOBOX.CATEGORY}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tile>
                            </div>

                            <div className="col-12 col-xl-4 ">
                              <Tile
                                heading={"Rates"}
                                height={"300px"}
                                className={`${styles["section-title"]} px-4 pt-2 pb-0 overflow-auto`}
                              >
                                <div className="px-2">
                                  <div className="ms-3 mt-3 right-align">
                                    <Label className="mb-1 label">
                                      Estimate Fee
                                    </Label>
                                    <div className=" d-flex  align-items-center ">
                                      <NumericTextBox
                                        id="netAmount"
                                        onChange={(e) =>
                                          handleInputChange(
                                            e.value,
                                            "estimateValue",
                                          )
                                        }
                                        value={inputState["estimateValue"]}
                                        style={{
                                          width: "265px",
                                          height: "32px",
                                        }}
                                        className="me-2 pe-2"
                                        spinners={false}
                                        format="n2"
                                        placeholder="0.00"
                                      />
                                      {formType !== "ADD_NEW" && (
                                        <img
                                          src={EstimateFeeImage}
                                          className="cursor-pointer"
                                          width={18}
                                          height={18}
                                          alt="Estimate Fee"
                                          onClick={() =>
                                            setShowEstimatedFee(true)
                                          }
                                        />
                                      )}
                                    </div>
                                    {showEstimatedFee && (
                                      <EstimateFee
                                        cancelEdit={() =>
                                          setShowEstimatedFee(false)
                                        }
                                        matter={
                                          matterDetails?.matterViewDetails[
                                            props.reference
                                          ]?.data?.matterId
                                        }
                                      />
                                    )}
                                  </div>
                                  <div className="d-flex align-items-center mt-3 ms-3">
                                    <FormComboBox
                                      placeholder={"Select Rate Type"}
                                      iconClassName="wa"
                                      wf={true}
                                      isStyled={true}
                                      width={"265px"}
                                      data={[
                                        {
                                          rateType: "FeeEarnerDefault",
                                          representation: "Fee Earner Default",
                                        },
                                        {
                                          rateType: "MatterFlatRate",
                                          representation: "Matter Flat Rate",
                                        },
                                        {
                                          rateType: "RateCategory",
                                          representation: "Rate Category",
                                        },
                                      ]}
                                      textField="representation"
                                      state={comboBoxState}
                                      name={CONSTANT.COMBOBOX.RATE_TYPE}
                                      onChangeComboBox={handleComboBoxChange}
                                      val={
                                        comboBoxState[
                                          CONSTANT.COMBOBOX.RATE_TYPE
                                        ]
                                      }
                                    />
                                  </div>
                                  {comboBoxState[CONSTANT.COMBOBOX.RATE_TYPE] &&
                                    typeof comboBoxState[
                                      CONSTANT.COMBOBOX.RATE_TYPE
                                    ] === "object" &&
                                    comboBoxState[CONSTANT.COMBOBOX.RATE_TYPE]
                                      ?.rateType === "MatterFlatRate" && (
                                      <div className="mt-3 ms-3">
                                        <Label className="mb-1 label d-block">
                                          Fix Rate
                                        </Label>
                                        <NumericTextBox
                                          id="netAmount"
                                          onChange={(e) =>
                                            handleInputChange(
                                              e.value,
                                              "rateValue",
                                            )
                                          }
                                          value={inputState["rateValue"]}
                                          style={{
                                            width: "265px",
                                            height: "32px",
                                          }}
                                          className="right-align pe-2"
                                          spinners={false}
                                          format="n2"
                                          placeholder="0.00"
                                        />
                                      </div>
                                    )}
                                  {comboBoxState[CONSTANT.COMBOBOX.RATE_TYPE] &&
                                    typeof comboBoxState[
                                      CONSTANT.COMBOBOX.RATE_TYPE
                                    ] === "object" &&
                                    comboBoxState[CONSTANT.COMBOBOX.RATE_TYPE]
                                      ?.rateType === "RateCategory" && (
                                      <div className="mt-3 ms-3">
                                        <FormComboBox
                                          wf={true}
                                          isStyled={true}
                                          width={"265px"}
                                          onChangeComboBox={
                                            handleComboBoxChange
                                          }
                                          data={rateCategories}
                                          textField="rateCategoryName"
                                          state={comboBoxState}
                                          name={CONSTANT.COMBOBOX.RATE_CATEGORY}
                                          placeholder="Select Rate Category"
                                          val={
                                            comboBoxState[
                                              CONSTANT.COMBOBOX.RATE_CATEGORY
                                            ]
                                          }
                                          required={true}
                                          showAsterisk={
                                            !comboBoxState[
                                              CONSTANT.COMBOBOX.RATE_CATEGORY
                                            ]
                                          }
                                        />
                                      </div>
                                    )}
                                </div>
                              </Tile>

                              <div className="mt-2">
                                <Tile
                                  heading="Marketing"
                                  height={"280px"}
                                  className="p-3 ps-4 pe-4 pt-2 pb-0 overflow-auto"
                                >
                                  <div className="px-2">
                                    <div className="container">
                                      <div className="row">
                                        <FormComboBox
                                          onChangeComboBox={
                                            handleComboBoxChange
                                          }
                                          wf={true}
                                          isStyled={true}
                                          width={"280px"}
                                          textField="sourceName"
                                          data={activeSourcesData}
                                          state={comboBoxState}
                                          name={CONSTANT.COMBOBOX.SOURCE}
                                        />
                                      </div>
                                      <div className="row">
                                        <FormComboBox
                                          onChangeComboBox={
                                            handleComboBoxChange
                                          }
                                          wf={true}
                                          isStyled={true}
                                          className={"mt-3"}
                                          width={"280px"}
                                          onFilterChange={
                                            applicationfilterChange
                                          }
                                          textField="referrerName"
                                          data={activeReferrersData}
                                          state={comboBoxState}
                                          name={CONSTANT.COMBOBOX.REFERRRER}
                                        />
                                      </div>
                                      {formType === "ADD" && (
                                        <div className="row mt-3 right-align">
                                          <Label className="mb-1 label">
                                            Estimate Fee
                                          </Label>
                                          <NumericTextBox
                                            id="netAmount"
                                            onChange={(e) =>
                                              handleInputChange(
                                                e.value,
                                                "estimateValue",
                                              )
                                            }
                                            value={inputState["estimateValue"]}
                                            style={{
                                              width: "280px",
                                              height: "32px",
                                              marginLeft: "12px",
                                            }}
                                            spinners={false}
                                            format="n2"
                                            placeholder="0.00"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Tile>
                              </div>
                            </div>
                          </div>
                        )}
                      </TileWrapper>
                    </TabStripTab>
                    {formType === "EDIT" && (
                      <TabStripTab
                        title={
                          <PageTabItemTitle
                            title="Completion"
                            index={1}
                            selected={selected}
                          />
                        }
                      >
                        <TileWrapper>
                          <div className="row g-2">
                            <div className="col-6">
                              <Tile
                                heading="Completion"
                                height={"300px"}
                                className="px-4 pt-2 pb-0 overflow-auto"
                              >
                                <Checkbox
                                  label="Closed"
                                  value={closed}
                                  onChange={(e) => {
                                    setClosed(e.value);
                                    if (e.value) {
                                      setDateState((prev) => ({
                                        ...prev,
                                        [CONSTANT.DATE.CLOSED_DATE]: new Date(),
                                      }));
                                    }
                                  }}
                                />
                                <FormDate
                                  disabled={!closed}
                                  wf={true}
                                  isStyled={true}
                                  className={
                                    "mt-3 form-date-picker note-date-picker"
                                  }
                                  width={"260px"}
                                  label={CONSTANT.DATE.CLOSED_DATE}
                                  onChangeDate={handleDateChange}
                                  state={dateState}
                                />
                                <FormInput
                                  state={inputState}
                                  className={"mt-3"}
                                  wf={true}
                                  isStyled={true}
                                  width={"260px"}
                                  label={CONSTANT.INPUT.LOCATION}
                                  onChangeInput={handleInputChange}
                                />
                              </Tile>
                            </div>{" "}
                            <div className="col-6">
                              <Tile
                                heading="GDRP"
                                height={"300px"}
                                className="px-4 pt-2 pb-0 overflow-auto"
                              >
                                <Checkbox
                                  label="Deleted"
                                  onChange={(e) => setDeleted(e.value)}
                                />
                                <FormDate
                                  disabled={!deleted}
                                  className={
                                    "mt-3 form-date-picker note-date-picker"
                                  }
                                  wf={true}
                                  isStyled={true}
                                  width={"260px"}
                                  label={CONSTANT.DATE.DELETED_DATE}
                                  onChangeDate={handleDateChange}
                                  state={dateState}
                                />
                              </Tile>
                            </div>
                          </div>
                        </TileWrapper>
                      </TabStripTab>
                    )}

                    <TabStripTab
                      title={
                        <PageTabItemTitle
                          title="Credit & Defaults"
                          index={formType == "EDIT" ? 2 : 1}
                          selected={selected}
                        />
                      }
                    >
                      <TileWrapper>
                        <div className="row g-2">
                          <div className="col-12 col-xl-6">
                            <Tile
                              height={"595px"}
                              className="p-3 ps-4 pe-4 pt-2 pb-0 overflow-auto h-100"
                              heading="Credit & Defaults"
                            >
                              <div>
                                <div className="d-flex flex-column right-align">
                                  <Label className="mb-1 label d-block">
                                    {CONSTANT.INPUT.WIP_CREDIT_LIMIT.replaceAll(
                                      "_",
                                      " ",
                                    )}
                                  </Label>
                                  <NumericTextBox
                                    onChange={(e) =>
                                      handleInputChange(
                                        e.value,
                                        CONSTANT.INPUT.WIP_CREDIT_LIMIT,
                                      )
                                    }
                                    value={
                                      inputState[
                                        CONSTANT.INPUT.WIP_CREDIT_LIMIT
                                      ]
                                    }
                                    style={{ width: "260px", height: "32px" }}
                                    spinners={false}
                                    format="n2"
                                    placeholder="0.00"
                                  />
                                </div>

                                <div className="mt-3" />
                                <div className="d-flex flex-column right-align">
                                  <Label className="mb-1 label d-block">
                                    {CONSTANT.INPUT.DISP_CREDIT_LIMIT.replaceAll(
                                      "_",
                                      " ",
                                    )}
                                  </Label>
                                  <NumericTextBox
                                    onChange={(e) =>
                                      handleInputChange(
                                        e.value,
                                        CONSTANT.INPUT.DISP_CREDIT_LIMIT,
                                      )
                                    }
                                    value={
                                      inputState[
                                        CONSTANT.INPUT.DISP_CREDIT_LIMIT
                                      ]
                                    }
                                    style={{ width: "260px", height: "32px" }}
                                    spinners={false}
                                    format="n2"
                                    placeholder="0.00"
                                  />
                                </div>

                                <div className="mt-3" />
                                <div className="d-flex flex-column right-align">
                                  <Label className="mb-1 label d-block">
                                    {CONSTANT.INPUT.BILL_CREDIT_LIMIT.replaceAll(
                                      "_",
                                      " ",
                                    )}
                                  </Label>
                                  <NumericTextBox
                                    onChange={(e) =>
                                      handleInputChange(
                                        e.value,
                                        CONSTANT.INPUT.BILL_CREDIT_LIMIT,
                                      )
                                    }
                                    value={
                                      inputState[
                                        CONSTANT.INPUT.BILL_CREDIT_LIMIT
                                      ]
                                    }
                                    style={{ width: "260px", height: "32px" }}
                                    spinners={false}
                                    format="n2"
                                    placeholder="0.00"
                                  />
                                </div>
                                <FormComboBox
                                  className={"mt-3"}
                                  cb={!!comboBoxState[CONSTANT.COMBOBOX.DDA_BANK]}
                                  wf={true}
                                  width={"260px"}
                                  isStyled={true}
                                  onChangeComboBox={handleComboBoxChange}
                                  onFilterChange={ddaBankFilterChange}
                                  textField="display"
                                  data={ddaBankList}
                                  state={comboBoxState}
                                  name={CONSTANT.COMBOBOX.DDA_BANK}
                                />
                                <FormComboBox
                                  className={"my-3"}
                                  cb={!!comboBoxState[CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL]}
                                  wf={true}
                                  isStyled={true}
                                  width={"260px"}
                                  onChangeComboBox={handleComboBoxChange}
                                  onFilterChange={profitAndLossfilterChange}
                                  data={profitAndLoss}
                                  textField="display"
                                  state={comboBoxState}
                                  name={CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL}
                                />
                                <FormComboBox
                                  className={"my-3"}
                                  cb={!!comboBoxState[CONSTANT.COMBOBOX.INTEREST_SCHEME]}
                                  wf={true}
                                  isStyled={true}
                                  width={"260px"}
                                  onChangeComboBox={handleComboBoxChange}
                                  onFilterChange={interestSchemesFilterChange}
                                  data={interestSchemes}
                                  textField="schemeName"
                                  state={comboBoxState}
                                  name={CONSTANT.COMBOBOX.INTEREST_SCHEME}
                                />
                              </div>
                            </Tile>
                          </div>
                          <div className="col-12 col-xl-6">
                            <Tile
                              className="p-3 ps-4 pe-4 pt-2 pb-0 overflow-auto"
                              height={"595px"}
                            >
                              <MatterPermissions
                                isView={false}
                                accessibleUsers={accessibleUsers}
                                setAccessibleUsers={setAccessibleUsers}
                                matterId={
                                  matterDetails?.matterViewDetails[
                                    props.reference
                                  ]?.data?.matterId
                                }
                              />
                            </Tile>
                          </div>
                        </div>
                      </TileWrapper>
                    </TabStripTab>
                    {formType !== "ADD_NEW" && (
                      <TabStripTab
                        title={
                          <PageTabItemTitle
                            title="Undertakings"
                            index={formType === "EDIT" ? 4 : 3}
                            selected={selected}
                          />
                        }
                      >
                        <div style={{ width: "100%" }}>
                          <UndertakingsList
                            matterId={
                              formType === "ADD_NEW"
                                ? newMaterId || null
                                : matterDetails?.matterViewDetails[
                                    props.reference
                                  ]?.data?.matterId
                            }
                            clientId={
                              formType === "ADD_NEW"
                                ? comboBoxState[CONSTANT.COMBOBOX.CLIENT]
                                    ?.CustomerID
                                : matterDetails?.matterViewDetails[
                                    props.reference
                                  ]?.data?.clientId
                            }
                          />
                        </div>
                      </TabStripTab>
                    )}
                  </TabStrip>
                </form>
              </div>
            </div>
          </div>

          <DialogActionsBar>
            <div className="dialog-footer">
              <Button
                className="common-btn bgBtnSecondary border-0 me-2"
                onClick={props.setshowMatterForm}
              >
                Cancel
              </Button>
              <Button
                className="common-btn me-4"
                type="submit"
                form="matterForm"
              >
                {formType === "VIEW"
                  ? "Edit"
                  : formType === "EDIT"
                    ? "Update Matter"
                    : "Add Matter"}
              </Button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
      {addClient && (
        <Dialog
          title={"Add Client"}
          width={1350}
          onClose={() => {
            setAddClient(false);
          }}
          open={() => {
            setAddClient(true);
          }}
        >
          <div className={`container p-0 `}>
            <AddClients
              formId={"add"}
              title={`Add Client`}
              component={"Add Matters"}
              onChangeClient={(e) =>
                handleClientChange({
                  ContactName: e.name,
                  display: e.display,
                  CustomerID: e.id,
                  CustomerRef: e.ref,
                })
              }
              onClose={() => {
                setAddClient(false);
              }}
              open={() => {
                setAddClient(true);
              }}
            />
          </div>
          <div className="dialog-footer mt-2">
            <Button
              className="common-btn bgBtnSecondary border-0 me-4"
              onClick={() => {
                setAddClient(false);
              }}
            >
              Cancel
            </Button>
            <Button className="common-btn me-4" type="submit" form={"add"}>
              {"Add Client"}
            </Button>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default MatterForm;
